import { type MaskitoOptions } from '@maskito/core';
import { maskWithPlaceholder } from 'utils/maskito';

export const SSN_FORMAT = '###-##-####';
export const SSN_MASK = 'X';
export const SSN_PLACEHOLDER = 'XXX-XX-XXXX';

export const SSN_MASK_OPTIONS: MaskitoOptions = maskWithPlaceholder(
  [/\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
  SSN_PLACEHOLDER,
);
